import MenuIcon from '@mui/icons-material/Menu';
import { IconButton, Drawer, Box, Stack } from '@mui/material';
import { useState } from 'react';
import { Hashtag } from './Hashtag';
import Logo from "..\\src\\DJKLOGO.png";
import './Sidenav.css';

export default function SideNav() {

    const [navBarOpen, setNavBarOpen] = useState(false);

    function toggleNavBar() {
        setNavBarOpen(!navBarOpen)
    }

    const links = [
        { text: "#DJK.Startseite", link:"/", unterpunkt: false},
        { text: "#DJK.Verein", link: "/Verein", unterpunkt: false },
        { text: "#DJK.Webshop", link: "https://team.jako.com/de-de/team/djk_durlach_webshop_test/", unterpunkt: false },
        { text: "#DJK.Fußballschule", link: "https://fussballschule.djkdurlach.de/", unterpunkt: false },
        { text: "#Next.Level.Training", link: "https://fussballschule.djkdurlach.de/fussballschule", unterpunkt: true },
        { text: "#DJK.Fussball.Camps", link: "https://fussballschule.djkdurlach.de/fussball-camps" , unterpunkt: true },
        { text: "#DJK.Ball.Schule", link: "https://fussballschule.djkdurlach.de/ballschule", unterpunkt: true },
        { text: "#Mitglied.Werden", link: "/MitgliedWerden", unterpunkt: false },
    
]

    return (
        <>
            <IconButton onClick={toggleNavBar} className="sidenav-icon-button">
                <MenuIcon fontSize='large' />
            </IconButton>
            <Drawer open={navBarOpen} onClose={toggleNavBar} anchor='right'>
                <Box className="sidenav-box" role="presentation" onClick={toggleNavBar}>
                    <div className="sidenav-logo">
                        <img src={Logo} alt='DJK Durlach Logo' />
                    </div>
                    <Stack direction="column" className="sidenav-stack">
                        {links.map((link, index) => (
                            <a key={index} className={`sidenav-link ${link.unterpunkt ? 'unterpunkt' : ''}`} href={link.link} target={link.link.includes("http") ? "_blank" : ""} rel="noreferrer">
                                <Hashtag text={link.text} />
                            </a>
                        ))}
                    </Stack>
                </Box>
            </Drawer>
        </>
    );
}